const styles = {
  header: {
    border: '1px solid #ddd',
    backgroundColor: '#F5F5F5'
  },
  downloadLink: {
    color: '#0117DE'
  },
  disc: {
    listStyleType: 'disc'
  },
  noBullet: {
    listStyleType: 'none'
  },
  steps: {
    fontSize: '12px'
  },
  headerText: {
    fontWeight: 'bold'
  },
  italicText: {
    fontStyle: 'italic'
  },
  muted: {
    fontSize: '12px',
    color: 'rgb(158, 158, 158)'
  },
  header2: {
    fontSize: '24px'
  },
  title: {
    fontSize: '20px',
    fontWeight: '500',
    letterSpacing: '0.15px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  card: {
    boxShadow: 'none',
    width: '433px'
  },
  errorCard: {
    boxShadow: 'none',
    color: 'black',
    border: '1px solid #BE3838',
    borderTop: 'none'
  },
  errorCardHeader: {
    backgroundColor: 'rgba(190, 56, 56, 0.12)',
    borderTop: '1px solid #BE3838',
    borderBottom: '1px solid #BE3838',
    fontSize: '14px',
    color: '#000000'
  },
  border: {
    borderBottom: '1px solid rgb(158, 158, 158)',
    fontSize: '14px'
  },
  text: {
    fontSize: '14px',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  fileName: {
    float: 'right',
    fontSize: '14px',
    color: 'rgb(158, 158, 158)'
  },
  list: {
    paddingLeft: '0',
    listStyle: 'none'
  },
  errorList: {
  },
  errorListItem: {
    color: '#663D00'
  },
  fileList: {
    maxWidth: '376px',
    paddingTop: '15px'
  },
  fileListText: {
    fontSize: '14px',
    color: 'rgb(158, 158, 158)',
    verticalAlign: 'middle',
    display: 'inline-block'
  },
  fileListIcon: {
    fontSize: '14px',
    color: 'rgb(158, 158, 158)',
    verticalAlign: 'middle',
    display: 'inline-block',
    float: 'right'
  },
  stepIcon: {
    transform: 'scale(2)',
    color: '#E69343',
    verticalAlign: 'middle',
    display: 'inline-block',
    marginRight: '20px'
  },
  stepText: {
    fontSize: '16px',
    verticalAlign: 'middle',
    display: 'inline-block',
    fontWeight: 'bold'
  },
  tableRowCol: {
    whiteSpace: 'wrap',
    overflow: 'visible',
    paddingTop: '15px',
    paddingLeft: '20px'
  },
  uploadYourFileHeader: {
    marginTop: '10px',
    fontSize: '16px',
    fontWeight: '500'
  }
}

export {
  styles
}
